module.exports = {
	"level1": {
      "name": "Real name",
      "idcard": "Certificate type",
      "address": "Present residence address",
      "bank_number": "Bank Number",
      "wc": "OK",
      "name_nodata": "The Name cannot be empty",
      "id_card_nodata": "The Certificate number cannot be empty",
      "address_nodata": "The address cannot be empty",
      "bank_number_nodata": "Bank card number cannot be empty",
      "input-username":"Please enter your real name",
      "zjhm":"Certificate Number",
      "input-idcard":"Please enter your certificate number",
      "input-address":"Please input your address",
      "zjlx":"Types of valid ID",
      "qxzzjlx":"Please select types of valid ID",
      "sfz":"ID card",
      "hz":"Passport",
      "jsz":"Driver's license",
      "lxz":"Certificate for studying abroad",
      "zfbzh": "Alipay account",
      "qsrzfbzh": "Please enter your alipay account",
      "khh": "Account Opening",
      "qsrkhh": "Please enter your account bank",
      "yhkh": "Bank card number",
      "qsryhkh": "Please enter your bank card number",
      "zfzh": "Payment account",
      "qxzzfzh": "Please choose a payment account",
      "gjlb": "Country list",
      "qxzgjlb": "Please select country / Region"
    },
   "my":{
    "bindphone":"Bind Phone",
    "gqrcode":"Scan the following two-dimensional code or enter promotional code, confirm the registration",
    "mqrcode":"My Qrcode",
    "as":"Settings",
    "pc":"Junior certification",
    "ac":"Senior certification",
    "smrz":"Certification",
    "sfyz":"KYC authentication",
    "mm":"My assets",
    "ms":"Share",
    "me":"My Earnings",
    "zsr":"Total revenue",
    "mp": "My promotion",
    "yqhy": "Invite friends",
    "ar":"Records",
    "hc":"Help",
    "nodata":"no data",
    "med": "my earnings lines",
    "aes": "all earnings(USDT)",
    "one": "one",
    "two": "two",
    "three": "three",
    "four": "four",
    "ones": "one number",
    "twos": "two number",
    "threes": "three number",
    "fours": "four number",
    "promotion": "total",
    "customers": "My earnings",
    "total": "total",
    "usdt": "USDT",
    "wdzc": "My assets",
    "wdzc1":"My assets",
    "wyfx": "My Shares",
    "wdsy": "My Earnings",
    "wdtg": "My Promotion",
    "zhjl": "Records",
    "fbjl": "OTC transaction records",
    "zxkf": "Online Service",
    "wdxx": "My message"
   },
  "footer": {
    "home": "Home",
    "quotation": "Markets",
    "currency": "Exchange",
    "lever": "Contracts",
    "assets": "Balances",
    "my":"Accounts",
    "lc": "USDT earn"
  },
  "index": {
    "wdzc":"My assets",
    "xsbk":"Beginner's guide",
    "dlhkck":"View after login",
    "dl":"View after Login",
    "zxkf":"Contact Us",
    "function": "Services",
    "legal": "Fiat",
    "legaltxt": "Buy digital assets with fiat money",
    "levertxt": "An investment that is several times the amount of your ariginal fund",
    "c2c": "c2c",
    "c2ctxt": "Two-way trade for hedging",
    "increase": "Top Gainers",
    "innovate":"Top Innovate",
    "myshop": "my shop",
    "order": "order management",
    "myc2c": "c2c that I trade",
    "usercenter": "Personal Center",
    "myshare": "My Sharing Link",
    "releasec2c": "release c2c",
    "language": "Language",
    "security": "Security Center",
    "pay": "Payment method",
    "bindaddress":"Bind withdrawal address",
    "address": "withdrawal address",
    "aboutus": "About us",
    "logout": "Logout",
    "vol": "24H Vol",
    "jc":"JC exchange BEAU",
    "kjcb": "Quick Deposit",
    "zcbz": "BTC, USDT..."
  },
  "transaction": {
    "buy": "BUY",
    "sell": "SELL",
    "pwd": "Transaction password",
    "inputpass": "Password",
    "inputnum": "Amount",
    "limit": "Limit",
    "avaiable": "Available",
    "turnover": "turnover",
    "handicap": "Handicap",
    "number": "Qty",
    "nonumber":"Uncompleted Quantity",
    "numbered":"Quantity completed",
    "price": "Price",
    "marketprice": "Market",
    "cancel": "Cancel",
    "total": "All-stop trading",
    "time": "Time",
    "nomore": "No more",
    "nodata": "No record",
    "getmore": "Load more",
    "mycommission": "Orders",
    "currentbuy": "Current (Buy)",
    "currentsell": "Current (Sell)",
    "his": "History(Completed)",
    "currency": "Exchange",
    "option": "Operation",
    "wtime":"Completion time",
    "wnumber":"Quantity completed",
    "wprice":"Completion price"
  },
  "mk": {
    "high": "H",
    "low": "L",
    "vol": "24H",
    "newPrice":"Latest price",
    "product":"product",
    "name":"Name",
    "rank":"List of gains"
  },
  "deals": {
  	"issue_time":"Time",
	"issue_number": "Number",
	"white_book": "Book",
	"weburl": "Url",
	"video_url": "Video",
	"introduction": "Info",
	"onhand":"one hand equal",
	"position": "Position",
    "leverorder": "Leverage orders",
    "leverposition": "leveraged position",
    "inputprice": "Input price",
    "inputmul": "Input multiple",
    "selectmul": "Choose multiple",
    "onehand": "one hand equals",
    "hand": "Number of trading hands",
    "marketval": "Market Value",
    "bond": "Bond",
    "service": "service fee",
    "balance": "balance",
    "type": "Type",
    "risk": "Risk Rate",
    "total": "total profit",
    "onekey": "closing it",
    "makemore": "(Long)",
    "makeless": "(Short)",
    "current": "Open Orders",
    "all": "All",
    "weing": "In commission",
    "tding": "Trading",
    "ping": "Closing",
    "pied": "Closed",
    "ceiled": "withdrawn",
    "weprice": "commission price",
    "oprice": "Opening price",
    "nowprice": "current price",
    "zyprice": "stop earnings price",
    "zsprice": "stop-loss price",
    "canbond": "available margin",
    "optime": "Opening time",
    "pgtime": "Closing time",
    "znum": "Converted quantity",
    "gprice": "Overnight charges",
    "pcang": "Close",
    "revoke": "Withdrawal",
    "fee": "Fee",
    "you":"Optimal market price"
  },
  "assets": {
    "bzxz":"Currency selection",
    "copy": "Copy",
    "currency": "Currency",
    "lever": "Margin",
    "legal": "French currency",
    "curAccount": "transaction account",
    "total": "Equivalence of assets(USDT)",
    "leverAccount": "leverage account",
    "legalAccount": "French account",
    "avaiable": "available",
    "lock": "freeze",
    "conversion": "conversion",
    "exact": "transaction account",
    "transfer": "Transfer",
    "num": "quantity",
    "time": "time",
    "record": "record",
    "caidata": "financial record",
    "from": "From",
    "to": "To",
    "transnum": "Number of transfers",
    "all": "All",
    "canuse": "Available",
    "pmin": "Please enter the minimum number of transfers",
    "cmoney": "Deposit",
    "tmoney": "Withdraw",
    "caddress": "Charge address",
    "copyaddress": "Copy address",
    "a01":"Do not recharge any non-",
    "a02":"Assets to the above address，",
    "a03":"Otherwise, assets will not be recovered.",
    "a04":"Charging only supports the simple send method. Charging with other methods is temporarily unavailable. Please understand.",
    "a05":"After you recharge to the above address, you need the confirmation of the entire network node, one network confirmation and six network confirmation can withdraw money.",
    "a06":"Minimum recharge amount:",
    "a07":"The recharge of less than the minimum amount will not be recorded and cannot be returned.",
    "a08":"Your replenishment address will not change frequently, you can replenish; if there is any change, we will try to notify you through the network bulletin or mail.",
    "a09":"Make sure that the computer and browser are secure to prevent information from being tampered with or leaked.",
    "taddress":"Withdrawal address",
    "taddressm":"Please input a currency withdrawal address",
    "padd":"Enter or long press paste address",
    "rate":"handling fee",
    "dnum":"Number of accounts arrived",
    "more":"Load more",
    "nodata":"No record yet",
    "search":"Search currency",
    "yczc": "Hide assets you don't have"
  },
  "td": {
    "drecord": "Order record",
    "orecord": "Completed orders",
    "filter": "Filter",
    "tdtype": "transaction type",
    "buy": "buy",
    "sell": "sell",
    "wantbuy": "Purchase",
    "dstatus": "Order status",
    "nofinish": "Not finished",
    "finished": "Completed",
    "ceiled": "cancelled",
    "payed": "Paymented",
    "waitPay": "Payment to be made",
    "reset": "reset",
    "confirm": "confirm",
    "time": "Time",
    "num": "Number",
    "tdtotal": "Amount",
    "call": "Contact each other",
    "buyer": "buyer",
    "seller": "Seller",
    "Sprice": "Unit price",
    "price": "price",
    "ptime": "Order time",
    "cnum": "reference number",
    "tdceil": "Cancel Trading",
    "sureReceive": "Confirmation of receivables",
    "conPay": "Confirmation of payment",
    "ppay": "Please pay",
    "paynext": "Please pay to the following account",
    "tdPrice": "Unit price",
    "tdNum": "Number",
    "payInfo": "Payment Information",
    "accountInfo": "Account Information",
    "receiver": "payee",
    "open": "Opening Bank",
    "pcnum": "When making payment, please fill in the reference number",
    "imPay": "I have paid",
    "tdAttion": "Reminder",
    "odCeil": "Cancellation of orders",
    "at01": "Your remittance will go directly into the seller's account, and the digital assets sold by the seller during the transaction will be protected by the platform custody.",
    "at02": "Please complete the payment within the specified time, and be sure to click 'I have paid'. After the seller confirms the receipt, the system will transfer the digital assets to your account.",
    "at03": "if the buyer cancels the order three times on the same day, it will be limited to the purchase function on that day.",
    "sureImpay": "Please confirm that you have paid the seller.",
    "badClick": "Malicious clicks will freeze accounts directly.",
    "notpay": "I haven't paid the other party yet.",
    "sureDpay": "Please confirm that the buyer has paid you.",
    "sureCeil": "Confirmation of Cancellation of Transactions",
    "notCeil": "If you have paid the seller, please do not cancel the transaction.",
    "dover": "The order has been completed and payment information cannot be viewed",
    "cover": "The order has been cancelled and payment information cannot be viewed",
    "payFast": "Please pay the seller as soon as you confirm the payment",
    "payClick": "If you have transferred payment to the seller, please make sure to click the 'I have paid' button in the lower right corner, otherwise it may cause financial losses.",
    "pwait": "Please wait for the buyer to pay.",
    "pwd": "Trading password",
    "ppwd": "Transaction password",
    "sure": "sure",
    "alipay": "Alipay",
    "wechat": "Wechat",
    "bank": "bank card",
    "realName": "Real Name",
    "knum": "card number",
    "pprice": "Unit price",
    "pnum": "Quantity",
    "min": "Minimum trading volume",
    "pmin": "Minimum transaction volume",
    "max": "Maximum trading volume",
    "pmax": "Maximum transaction volume",
    "buyNum": "Buy Quantity",
    "currency": "Currency",
    "pmethod": "Payment method",
    "choose": "Please choose",
    "mysells": "My sale",
    "mybuys": "My Purchase",
    "pcoin":"Monetary unit."
  },
  "fat": {
    "mybuy": "I want to buy",
    "mysell": "I want to sell",
    "ceil": "Cancel",
    "buy": "buy",
    "forsell":"sale",
    "forbuy":"Purchase",
    "sell": "sell",
    "price": "unit price",
    "bprice": "Purchase at a price",
    "bnum": "Buy by quantity",
    "pbtotal": "Total amount of French currency you want to buy",
    "pstotal": "Total amount of French currency you want to sell",
    "pbnum": "Quantity you want to buy",
    "psnum": "Quantity you want to sell",
    "allbuy": "All buy",
    "allsell": "All sell",
    "limit": "Limit",
    "tdtotal": "Amount",
    "autoceil": "s cancels automatically",
    "num": "Number",
    "submit": "place an order",
    "pwd": "Trading password",
    "ppwd": "Trading password",
    "sure": "confirm the order",
    "reTime": "Certified Business | Registration Time",
    "release": "Release",
    "allOrder": "Assembly Order",
    "dayOrder": "30 days order",
    "overOrder": "Completion Order",
    "rate": "Completion rate",
    "auPhone": "Mobile",
    "auName": "Real Name",
    "auHigh": "Advanced",
    "sellLine": "Sell online",
    "buyLine": "Buy online",
    "myshop": "my shop",
    "mybalance":"Merchant balance"
  },
  "auth": {
    "bh": "rejected",
    "bhr": "Your application was rejected for the following reasons:",
    "mycenter": "personal center",
    "test": "Authentication",
    "gotest": "To authenticate",
    "testing":"In audit",
    "tested": "Certified",
    "t1": "After certification, the withdrawal amount can be increased.",
    "t2": "c2c transactions can be conducted after certification.",
    "t3": "After certification, legal currency transactions can be carried out",
    "name": "Name",
    "account": "Account",
    "number": "Certificate number",
    "pname": "Your name",
    "pnum": "ID number",
    "id_card_face": "Please upload the front of the ID card",
    "id_card_back": "Please upload the back of the ID card",
    "upimg": "Please upload the front and back sides of the certificate, as well as the front photos with the certificate in hand.",
    "updata": "submit",
    "updata_again":"submit again"
  },
  "code": {
    "mycode": "my promotion code",
    "code": "Promotion Code",
    "qrcode": "sweep the two-dimensional code pattern above or input promotion code to confirm registration",
    "notice": "Notice",
    "about": "Relevant News"
  },
  "safe": {
    "title":"Account security",
    "center": "Security center",
    "qchc":"Clear cache",
    "yysz":"Language",
    "ssms":"Dark mode",
    "gywm":"About Us",
    "lgpwd": "Login password",
    "tkmm":"Withdrawal password",
    "paypwd": "payment password",
    "resetpwd": "Modify password",
    "paccount": "Your cell phone number or mailbox",
    "next": "Next step",
    "reset":"Modification",
    "stest": "Security verification",
    "ceil": "Cancel",
    "pcode": "Verification code",
    "send": "Get CAPTCHA",
    "sure": "Confirmation",
    "newPwd": "Reset password",
    "len": "Password needs 6-20 characters",
    "ppwd": "Password",
    "reppwd": "Password again.",
    "repwd": "Reset password",
    "zpwd":"Transaction password"
  },
  "met": {
    "add": "Add way",
    "open": "Name of the opening bank",
    "bank": "Bank Account",
    "realname": "Real Name",
    "alipay": "Alipay account",
    "wename": "Wechat nickname",
    "wechat": "Wechat account",
    "save": "Save",
    "popen": "Name of the opening bank",
    "pbank": "Account number of the opening bank",
    "pname": "Real name",
    "palipay": "Alipay account",
    "pwename": "Weixin nickname",
    "pweaccount": "Wechat account"
  },
  "ads": {
    "tas": "Ticket address",
    "address": "Address",
    "noads": "You don't have an address yet.",
    "adds": "Address",
    "padd": "Withdrawal or paste address",
    "remark": "Remark",
    "cel": "Delete"
  },
  "call": {
    "callme": "Contact us",
    "privacy": "Privacy policy"
  },
  "jc": {
    "title": "JC Conversion BEAU",
    "bind": "Bind accounts",
    "balance": "JC balance",
    "cannum": "Available JC Quantity:",
    "new": "BEAU latest price:",
    "exnum": "Exchange quantity:",
    "pnum": "JC quantity",
    "canex": "Convertible BEAU Quantity:≈",
    "exnow": "Immediate exchange",
    "record": "Exchange record",
    "exprice": "Exchange price:",
    "extime": "Exchange time",
    "not": "The number of available integrals is insufficient",
    "usenum": "Use JC Quantity",
    "paccount": "Account number",
    "ppwd": "Password",
    "gotd":"Transaction"
  },
  "lg": {
    "welcome":"Welcome! Please Login",
	  "hsa": "have account?",
    "lgs": "Login",
    "lgbt": "Logon",
	  "lgtel":"mobile login",
    "lgeml":"email login",
    "paccount": "Phone number or E-mail",
    "ppwd": "Please enter your password",
    "ppwd2": "Please confirm your password",
    "qsryqm": "Invitation code",
    "pcode": "Verification code",
    "mepwd": "Remember passwords",
    "noaccount": "Haven't got an account yet?",
    "qregister": "Register",
    "register": "Register",
    "phregister": "Register by phone",
    "emregister": "Register by email",
    "noset": "Can not be modified after registration",
    "pphone": "Mobile phone number",
    "next": "Next step",
    "have": "Has there been a account?",
    "ceil": "Cancel",
    "msgtest": "Short Message Verification",
    "send": "Get CAPTCHA",
    "sure": "OK",
    "email": "email address",
    "emtest": "mailbox validation",
    "scode": "send authentication code",
    "pemcode": "verification code",
    "ppcode": "verification code",
    "ftpwd": "Forgot your password?",
    "ftpwds": "Forget passwords",
    "ptext": "Cell phone number or mailbox",
    "safetest": "security verification",
    "sjh":"cell-phone number",
    "yzm":"Verification Code",
    "mm":"Password",
    "qrmm":"Confirm password",
    "mmcd":"Password length 8-12 bits",
    "language": "Language",
    "kjzc": "Contact us for quick registration",
    "kjzc1": "Can't receive CAPTCHA?",
    "kjzc2": "Quick registration",
    "wyzx": "I already know",
    "qtxyxzh": "Important: Please fill in a valid email address or mobile phone number, which can be used to retrieve your password"
  },
  "gjrz":{
    "title":"Senior certification",
    "t1":"1. Images of less than 8 MB and in JPG, JPEG, or PNG formats are supported.",
    "t2":"2. ID document photos must be clear and shall not be modified or blocked. The personal photo, document number, and document holder’s name must be clearly visible. ",
    "t3":"3. Photos must be taken without any headwear, and are recommended to not include the use of makeup. The facial features of the document holder should be clear and recognizable, and their arms should be fully exposed.",
    "t4":"OK",
    "bh":"Reject",
    "shz":"Under review",
    "shtg":"Approved",
    "nyrzcg":"You have been certified successfully",
    "sczjz": "Upload ID photos",
    "sczjzmz": "Upload photo of front of ID document",
    "sczjbmz": "Upload photo of back of ID document",
    "scgrqmz": "Upload of documents and personal signature"
  },
  "chongzhi":{
    "title":"Deposit",
    "cbjl": "Deposit record",
    "t1":"Qty",
    "t2":"Please input quantity",
    "t3":"Voucher description(Optional)",
    "t4":"Please input description",
    "t5":"Voucher image",
    "t6":"OK",
    "t7":"Chain name",
    "t8":"QR code",
    "t9":"Save QR code",
    "t10":"Charging address",
    "t11":"Copy",
    "zy": "Important",
    "tips1": "Please do not top up any assets that are not in this currency to the above address otherwise the assets cannot be retrieved",
    "tips2": "1. Wallet/platform compatibility: that is, the network is supported; if the target platform does not support your withdrawal network, the assets cannot be retrieved.",
    "tips3": "2. Your top-up network and the target platform are the same; if you choose the target address is the Ethereum network, but the top-up chooses the TRC20 smart chain, you may not be able to retrieve your digital assets.",
    "tips4": "3. Make sure your address and amount are correct before recharging.",
    "tips5": "Reminder: Due to the anonymity and privacy of the block network, once you enter the wrong information, you will lose the corresponding assets. Please check your recharge address and quantity carefully"
  },
  "tibi":{
    "title":"Withdraw",
    "tbjl": "Withdrawal record",
    "t1":"Withdrawal address",
    "t2":"Please enter the withdrawal address",
    "t3":"Withdrawal quantity",
    "qsrtbsl":"Please enter the quantity of withdrawal currency",
    "t4":"Minimum",
    "t5":"Transaction password",
    "t6":"Please enter the transaction password",
    "t7":"Fee",
    "t8":"Quantity transferred into the account",
    "t9":"OK",
    "sc":"Delete",
    "bj":"Edit",
    "bq": "Tag(Memo)",
    "qsrbq":"Please enter the tag",
    "yhktx":"Bank card withdrawal",
    "yhmc": "Bank Name",
    "qsryhmc": "Please enter the Bank name",
    "yhzh": "Bank Account ",
    "qsryhzh":"Please enter the Bank account",
    "gjhkdm": "SWIFT Code",
    "qsrgjhkdm":"Please enter the SWIFT Code",
    "yhdz": "Bank address",
    "qsryhdz":"Please enter the Bank address",
    "skrxm": "Payee Name",
    "qsrskrxm":"Please enter the Payee name",
    "skrdh": "Payee Phone",
    "qsrskrdh":"Please enter the Payee phone",
    "skrdz": "Payee Address",
    "qsrskrdz":"Please enter the Payee address"
  },
  "huazhuan":{
    "title":"USDT transfer",
    "t1":"Exchange account balance",
    "t2":"Margin account balance",
    "t3":"Transfer quantity",
    "t4":"Please input quantity",
    "t5":"Transfer direction",
    "t6":"From",
    "t7":"Exchange account",
    "t8":"To",
    "t9":"Margin account",
    "t10":"OK",
    "zf": "Payment",
    "ky": "Available",
    "dd": "Get",
    "qbdh": "Exchange All",
  },
  "banner":{
    "title": "Details"
  },
  "download":{
    "t1": "Trade anytime anywhere",
    "xz": "Download"
  },
  "xgdlmm":{
    "title": "Modify login password",
    "zh":"Account",
    "zhts":"Mobile phone number or email",
    "yzm":"Verification code",
    "yzmts":"verification code",
    "hqyzm":"Get CAPTCHA",
    "mm":"Password",
    "mmts":"Password length 6-12 characters",
    "qrmm":"Confirm password",
    "send":"Get CAPTCHA",
    "qr":"OK"
  },
  "sztkmm":{
    "title":"Set withdrawal password",
    "dlmm":"Login password",
    "dlmmts":"Please enter the login password",
    "xmm":"New password",
    "mmts":"Password length 6 digits",
    "qrmm":"Confirm password",
    "qr":"OK",
    "qd": "OK",
    "sztkts": "Tip: Please go to the Security Center to set the transaction password"
  },
  "rule":{
    "title":"Event Rules",
    "title2":"Rules",
    "title3":"Activity"
  },
  "news":{
    "title":"My message",
    "ckxq":"View details",
    "gg":"Notice"
  },
  "xsbk":{
    "title":"Beginner's guide"
  },
  "search":{
    "qx":"cancel",
    "rmss":"Hot search",
    "ss": "search"
  },
  "wdtg":{
    "title": "Invite your best friend to",
    "yq": "join you on commission",
    "zyj": "",
    "wdyqlj":"My invitation link",
    "wdyqm":"My invitation code",
    "schbyq":"Generate a poster invitation",
    "ljtgsy":"Total revenue",
    "ljkh":"Total users(persons)",
    "tkrs":"Number of invitations",
    "ljyj":"Cumulative commission",
    "yjmx":"Commission details",
    "ljyjjl":"Cumulative commission awards (USDT",
    "ljsy":"Total revenue",
    "ljyqjl":"Cumulative invitation awards (USTD)",
    "fxd":"Share to",
    "wxhy":"WeChat friends",
    "wxpyq":"WeChat moments",
    "bctp":"Save pictures",
    "qx":"Cancel",
    "t1": "You can take all the profits",
    "t2": "from the coin-flipping",
    "t3": "Identify the image or scam it"
  },
  "bzhl":{
    "title":"Holding Rebates",
    "gz":"Rules",
    "tgdd":"Escrow order",
    "zztgdzj":"Funds in custody",
    "yjjrsy":"Estimated daily",
    "ljsy":"Total revenue",
    "tgzdd":"Order in custody",
    "cljxcp":"Strategic campaign products",
    "dbxe":"Single limit",
    "rsyl":"Daily rate of return",
    "zq":"Cycle",
    "qmr":"Go and buy",
    "bbzhzc": "Account assets",
    "zcc": "总资产(USDT)",
    "dd":"Orders",
    "buy":"Buy in",
    "jxcp":"Featured Products",
    "ckdd":"Check order",
    "gd":"more",
    "xzbzts": "Simple and safe. Dividends can be selected in multiple currencies",
    "qtbz": "Other coins"
  },
  "bzhlgm":{
    "title":"Profits from brick removal",
    "bzhld":"Profits from brick removal USDT",
    "qtzq":"USDT 7-day cycle",
    "rsyl":"Yield(%)",
    "lczq":"Financial cycle",
    "dbxe":"Single remittance quota (USDT)",
    "pxsj":"Dividend payout time",
    "mr":"Daily",
    "dqfh":"Return when due",
    "tgzj":"Custody capital",
    "tqsh":"Early redemption",
    "yjsy":"Anticipated income (USDT)",
    "kyzc":"Available assets (USDT)",
    "cpjs":"About Our Products",
    "tgje":"Custody amount",
    "qsrtgje":"Please enter the custody amount",
    "qb":"All",
    "rm":"Buy now",
    "cpzq":"Product cycle",
    "jxr":"計息日",
    "jiexr":"結息日",
    "yjdzr":"預計到賬日",
    "gz":"Know the rules and interests"
  },
  "bzhlwdtg":{
    "title":"Order status",
    "tgz":"In custody",
    "ywc":"Completed",
    "ysh":"Redeemed",
    "tgje":"Custody amount/Custody time",
    "rsyl":"Daily return rat",
    "yhl":"Profited",
    "xdsj":"Ordering time",
    "sh":"Redemption",
    "ddxq":"Order details",
    "ddh":"Order No. "
  },
  "bzjj":{
    "t1": "Earn every day",
    "t2": "Brick removal is a process which transfers USDT to the platform, and professional platform teams have the authority to move bricks. Participants can share part of the platform's brick removal income during the capital custody period.",
    "cpld": "Product highlights",
    "scsq": "Deposit&take anytime",
    "pxzq": "Dividend cycle",
    "mtxf": "Distribute daily",
    "hqlx": "Current interest",
    "zj": "100% fund",
    "aqbz" :"Security",
    "jjrsy": "Holiday earnings",
    "sybjd": "Continuous profit",
    "bjd": "uninterrupted",
    "cgcrh": "After successful deposit",
    "dtqx": "interest value on the day",
    "jglz": "For example",
    "syjs": "Calculation of revenue",
    "cont1": "If a members has deposited 10,000 U on the platform and selected financial products with a maturation cycle of seven days and a daily return rate of 0.3-0.5%, then the daily return is as follows: ",
    "cont2": "Minimum: 10,000 U*0.3%=30U",
    "cont3": "Maximum: 10,000 U*0.5%=50U",
    "cont4": "namely, After 7 days, you can receive 210-350 U of income. This income will be distributed daily, and distributed income can be accessed at any time. The principal will automatically return to your wallet account after the expiration of the period.",
    "gywyj": "About liquidated damages",
    "cont5": "If you want to transfer out the undue principal, you will be subject to liquidated damages, which equals to default settlement ratio, multiplied by the remaining days, multiplied by the investment quantity",
    "cont6": "For example: If the default settlement ratio of the product is 0.4%, and is due to mature in 3 days, with an investment quantity of 1000, then the liquidated damages= 0.4%*3*1000=12 U, and the actual returned principal will be 1000 U-12 U=988 U",
    "wycy": "I want to join"
  },
  "zyzs":{
    "title":"Take profit & stop loss",
    "zy":"Take profit",
    "zs":"Stop loss",
    "qsrzyjg":"Please enter a Take Profit price",
    "qsrzsjg":"Please enter a Stop loss price",
    "cfjglx":"Trigger Price Type:",
    "zsjg":"Index price",
    "scjg":"Market price",
    "pcfs":"Methods to Close positions:",
    "kpcw":"Closeout",
    "qbcw":"All positions",
    "wxts":"Please note:",
    "cont": "The Close positions of the market price may create the possibility of failing to make an order at market price, or to successfully take profit/stop loss due to sharp market fluctuations and other problems.",
    "qr":"OK"
  },
  "bbjy":{
    "mr":"Buy",
    "mc":"Sell",
    "mai":"Purchase",
    "sell":"Sell",
    "xj":"Limit",
    "sj":"Market",
    "pk":"Position",
    "jg":"Price",
    "sl":"Qty",
    "ss":"Quantity",
    "mrl":"Buying volume",
    "mcl":"Selling volume",
    "ky":"Available",
    "km":"Available",
    "ksell":"Marketable",
    "jye":"Turnover",
    "dqwt":"Current entrustment",
    "lswt":"Historical entrustment",
    "jj":"Info",
    "wtzl":"Total",
    "wtjg":"Entrustment price",
    "ycjl":"Completed trading volume",
    "cjjj":"Average transaction price",
    "cd":"Withdrawal",
    "xd":"Order",
    "wqcj":"A complete deal",
    "ywc":"Completed",
    "ycd":"Cancelled order",
    "zx":"Favorites",
    "scjg":"Market price",
    "fhsj":"Issuing date",
    "fhsl":"Issuing number",
    "bps":"White Paper",
    "gw":"Official Website",
    "qx":"Cancel"
  },
  "hyjy":{
    "mai":"Purchase",
    "sell":"Sell",
    "kc":"Open positions",
    "pc":"Close positions",
    "cc":"Positions",
    "kp":"Close",
    "kpc":"Close short",
    "kcc":"Positions",
    "kkd":"Open long",
    "kpd":"Long close",
    "kkk":"Open short",
    "xj":"Limit",
    "sj":"Market",
    "xjwt":"Limit order",
    "sjwt":"Market price",
    "pk":"Position",
    "jg":"Price",
    "sl":"Qty",
    "gg":"Lever",
    "tzgg":"Control lever",
    "ggbs": "Leverage",
    "mrl":"Buying volume",
    "ky":"Available",
    "jye":"Turnover",
    "dqwt":"Current entrustments",
    "lswt":"Historical entrustment",
    "ptwt":"Ordinary entrustments",
    "dqwtmr":"Current entrustments(Buy)",
    "dqwtmc":"Current entrustments(Sell)",
    "hywt":"Contract entrustments",
    "jj":"Info",
    "wtzl":"Total",
    "wtjg":"Entrustment price",
    "ycjl":"Completed trading volume",
    "cjjj":"Average transaction price",
    "qbcd":"Withdraw all orders",
    "cd":"Withdrawal",
    "xd":"Order",
    "wqcj":"A complete deal",
    "ywc":"Completed",
    "ycd":"Cancelled order",
    "zx":"Favorites",
    "scjg":"Market price",
    "fhsj":"Issuance date",
    "fhsl":"Issuance number",
    "bps":"White Paper",
    "gw":"Official website",
    "mrzd":"Long open",
    "mrpk":"Short close",
    "mczk":"Short open",
    "mcpd":"Long close",
    "mrkdkz":"Long open (bullish)",
    "mrpkkz":"Short close (bullish) ",
    "mckkkd":"Short open (bearish)",
    "mcpdkd":"Long close (bearish)",
    "yxhy":"Perpetual contract",
    "dc":"Long positions",
    "kcjj":"Open position average price(BUSDT)",
    "wsxyl":"Unrealized profit(BUSDT)",
    "ygqpj":"Estimated strong parity(BUSDT)",
    "syl":"Rate of return",
    "cwbzj":"Position margin(BUSDT)",
    "cw":"Positions (No.)",
    "cwjz":"Position value(BUSDT)",
    "bzjl":"Margin rate",
    "kpz":"Close (No.) ",
    "bdzs":"Underlying index",
    "tzbzj":"Adjust margin",
    "zyzs":"Take profit & stop loss",
    "zjbzj":"Increase margin",
    "jsbzj":"Reduce margin",
    "tyhy":"Experience Contract",
    "ccz":"Position (No.)",
    "cwbzjt":"Position margin(TBTC)",
    "zdzjbzj":"Maximum margin increase(TBTC)",
    "zjbzjt":"Margin increase(TBTC)",
    "zhang":"Qty",
    "qblx":"All types",
    "qb":"All",
    "ccjg":"Positions price",
    "ccsl":"Positions Qty",
    "yk":"Profit and loss",
    "ccsj":"Positions time",
    "zy":"Take profit",
    "zs":"Stop loss",
    "zje":"Total amount",
    "kcs":"Open positions Qty",
    "kcjg":"Open positions price",
    "ss":"Lots",
    "hand":"1 lots =",
    "qx":"Cancel",
    "qr":"OK"
  },
  "kxt":{
    "gao":"H",
    "di":"L",
    "wtgd":"Order",
    "cj":"Deal",
    "jj":"Info",
    "sj":"Time",
    "fx":"Direction",
    "jg":"Price",
    "sl":"Quantity",
    "mr":"Buy",
    "mc":"Sell",
    "mp":"Bid",
    "sp":"Selling",
    "slb":"Qty",
    "fhsj":"Issuing date",
    "fhsl":"Issuing number",
    "bps":"White Paper",
    "gw":"Official website",
    "fz":"min",
    "xs":"hour",
    "tian":"day",
    "zhou":"week",
    "yue":"month",
    "gd":"More",
    "ft":"Subgraph",
    "zt":"Main graph",
    "sdt":"Depth image",
    "zx":"Favorites",
    "djck": "Click to view"
  },
  "zhjl":{
    "cbtb":"Deposit & Withdraw",
    "jymx":"Transaction details",
    "tgyj":"Promotion commission",
    "wwc": "Undone",
    "ywc": "Completed"
  },
  "zwsj":{
    "title":"No record"
  },
  "bzxz":{
    "title":"Token"
  },
  "jghy":{
    "jghy": "Swap",
    "yxhy": "Perpetual",
    "mz": "Bullish",
    "md": "Bearish",
    "gmj": "Purchase price",
    "jsj": "Settlement price",
    "xj": "Current price",
    "fx": "Direction",
    "sl": "Volume",
    "jgsj": "Delivery time",
    "gb": "Close",
    "jxxd": "Continue to place an order",
    "cclb": "Order list",
    "zc": "Current",
    "lscc": "History",
    "qblx": "All",
    "yk": "Profit",
    "ddqr": "Order Confirmation",
    "dqsj": "Expire time",
    "jssj": "Delivery time",
    "sy": "Profit",
    "tzje": "Investment price",
    "zdje": "Lowest price 0",
    "kyye": "Balance: ",
    "kyye2": "Balance",
    "sxf": "Fee: ",
    "sxfl": "Fee",
    "jypz": "Name",
    "jyfx": "Direction",
    "qrxd": "Confirm",
    "fs": "Line",
    "dqye": "Current balance"
  },
  "kjmb":{
    "title":"Cryptocurrency",
    "gm": "Buy USDT",
    "wxts": "Reminder:",
    "wxts-copy": "Please copy the usdt address. You need to use this address to purchase usdt.",
    "copy": "Copy",
    "ljmb": "Buy cryptocurrency",
    "buy": "Buy",
    "cs": "Sell",
    "qx": "Cancel",
    "gmsl": "Purchase amount",
    "cssl": "Amount sold",
    "qsrgmsl": "Please enter the purchase amount",
    "qsrcssl": "Please enter the sale amount",
    "qxzzffs": "Please select mode of payment",
    "yhk": "Bank card",
    "wx": "Wechat",
    "zfb": "Alipay",
    "jg": "Price",
    "kyye": "Balance",
    "zxjysl": "Minimum number of transactions",
    "ts1": "1.All merchants who buy and sell are platform-certified merchants and provide 24-hour service.",
    "ts2": "2.If there is a dispute about the order, please contact customer service immediately for handling.",
    "fzcg": "Copy successful"
  },
  "tips":{
    "jymm": "Transaction password",
    "szjymm": "Set transaction password",
    "qsrjymm": "Enter transaction password",
    "jymmts": "Please go to the Security Center to set the transaction password"
  },
  "xyf":{
    "title": "Credit score",
    "pgsj": "Evaluation time"
  },
  "dzrz":{
    "title": "Address authentication",
    "sdddz":"Utility bill address",
    "tpsc": "Bill image upload",
    "ts": "Reminder: You need to fill in the address information and submit the utility bill or broadband address bill",
    "tips":"You need to fill in the address information and submit the utility bill or broadband address bill",
    "qsczdtp":"Please upload a picture of the bill"
  },
  "newReg":{
    "sjh": "Mobile",
    "yx": "Email",
    "yqm": "Invitation code",
    "yqm2": "Invitation code (optional)",
    "cjzh": "Create Account",
    "sysjhzyx": "Register with mobile number/email",
    "sj": "Mobile",
    "yhxy": "&lt;User Agreement&gt;",
    "yhxy2": "I have read and agree to the  and  &lt;User Agreement&gt; "
  },
  "mbwt":{
    "title": "Security issues",
    "mbwt": "Security issues",
    "qtxda": "Please fill in the answer",
    "qsrxmm": "Please enter a new password",
    "sydqmmcz": "Use current password reset",
    "zhmm": "Security issues Retrieve password",
    "ysz": "Has been set",
    "tg": "Ignore",
    "tj": "Submit",
    "zyts": "Important:",
    "zytsCont": "Do not disclose the secret answer and verification code, and keep in mind the security issue, which will help you retrieve your password"
  },
  "xbsg":{
    "title": "Newcoin",
    "wdsg": "Details",
    "scts": "Lockup days: ",
    "sy": "Remaining",
    "ljsg": "Subscribe now",
    "ysk": "Sold out",
    "xzjdy": "Subscribe now",
    "dy": "Subscribe",
    "fxjg": "issue price",
    "fxl": "Circulation",
    "ssrq": "Listing date",
    "yxqx": "Validity period",
    "qsrsl": "Please enter amount",
    "syl": "Remaining",
    "sgrq": "subscribe",
    "sgsl": "Amount",
    "bz": "Coin",
    "yebz": "Insufficient USDT balance",
    "tgsl": "Pass Qty",
    "shz": "under review",
    "wtg": "Did not pass",
    "ytg": "passed"
  },
  "wydb":{
    "title": "Borrow",
    "db": "Borrow",
    "dbz": "Borrow",
    "jl": "record",
    "jdzq": "Period (days)",
    "qhk": "To repay",
    "ljdb": "Cumulative(usdt)",
    "dhkbs" :"pending payment",
    "jkje": "Loan amount(usdt)",
    "qsrje": "Please enter amount",
    "rll": "Daily interest rate",
    "hkfs": "Repayment",
    "dqych": "Expired",
    "lx": "Interest",
    "fkjg": "Lender",
    "tpsc": "Credit loan (image upload)",
    "fwxx": "Housing information",
    "srzm": "Proof of income (employment relationship)",
    "yhmx": "Bank statement",
    "zjz": "ID photo",
    "yd": "I have read and agreed",
    "xy": "Apply for a loan agreement",
    "sqdb": "Click to apply for loan chains",
    "gb": "close",
    "qd": "OK",
    "ts": "Please check Apply for a loan agreement",
    "dbjl": "record",
    "hkhth": "Order Code",
    "wsh": "Unreviewed",
    "yfk": "Loan",
    "sqrq": "Application time",
    "zq": "cycle",
    "dbsl": "Number of ribs",
    "zhke": "Total payment",
    "yhkxq": "Repayment Details",
    "bqyhk": "Repayable in the current period(USDT)",
    "hktips": "Please make sure the balance is sufficient, if the balance is insufficient, please recharge first and then repay",
    "bj": "Principal",
    "jie": "Borrow",
    "ljhk": "Repay immediately",
    "qcz": "To deposit",
    "yebzqxcz": "Insufficient balance, please recharge first and then repay",
    "znj": "Late payment fee",
    "yqts": "Days Overdue"
  },
  "hkxq":{
    "dd":"Order",
    "fzhkdz":"Copy the repayment address",
    "hkxq": "Repayment Details",
    "zlx": "total interest",
    "zhk": "total repayments",
    "hkjg": "repayment agency",
    "qschkpz": "Please upload the repayment certificate",
    "hkpz": "repayment certificate"
  },
  "bbjyNew":{
    "jylx": "Types of",
    "jyze": "Amount"
  },
  "indexNew":{
    "title": "Add TokenSwap to the main interface",
    "t1": "Quick access to full screen experience",
    "t2": "Click on the toolbar below",
    "t3": "and select",
    "t4": "Add to Home Screen",
    "t5": "Add to desktop experience full version of TokenSwap" ,
    "t6": "Add to Favourites",
    "t7": "Find on Page"
  },
  "bind":{
    "title": "Email Authentication",
    "ybd": "Bound",
    "wbd": "Unbound",
    "yrz": "Verified",
    "wrz": "Unverified",
    "ts": "To protect your account, it is recommended to bind an email address",
    "qsryxdz": "email address"
  },
  "status":{
    "statusText": ['failure','under review','success'],
 },
 "tipsNew":{
   "wjmmts": "Recover password by verification code",
   "qscpztp": "Please upload the voucher image",
   "emailgsts": "Input mailboxes do not conform to the rules",
   "telgsts": "The mobile phone number is incorrect",
   "lcmmbyz": "Please confirm your password",
   "zdsl": "Min Qty ",
   "sldydy": "Quantity greater than or equal to",
   "zxtzsl": "Min Qty ",
   "ddz": "waiting",
   "xs": "hour",
   "min": "Minimum amount ",
   "max": "Maximum amount ",
   "yebz": "Insufficient balance",
   "qsrss": "Please input lots",
   "zdss": "Minimum lots",
   "yjj": "rejected",
   "shz": "Redemption",
   "zwkfcz": "This currency is not open for deposit",
   "jiaoge": "delivery",
    "zhang": "rise",
    "die": "fall",
    "cjxnzh": "Create virtual account"
 },
 "langNew2":{
  "flzq": "Rewards Hub",
  "qdjl": "Sign in reward",
  "mrqdjl": "Daily sign-in reward",
  "qd": "Sign in",
  "yqd": "Signed in",
  "hdgz": "Event Rules",
  "qdjl2": "Check-in record",
  "qdcg": "Sign in successfully",
  "yhd": "Acquired",
  "lq": "Receive",
  "dyt": "Day 1",
  "det": "Day 2",
  "dst": "Day 3",
  "dsit": "Day 4",
  "dwt": "Day 5",
  "dlt": "Day 6",
  "dqt": "Day 7",
  "jxz": "in progress"
},
"langNew":{
  "kp": "Opening",
  "zuoshou": "Received yesterday",
  "zg": "Highest",
  "zd": "Lowest",
  "dqjg": "Current price",
  "pcjg": "Closing price",
  "gd": "pending order",
  "gdj": "Pending order price",
  "gdjg": "Pending order price",
  "xfbzj": "Security deposit required: ",
  "ksrfw": "Available input range: ",
  "shou": "Lots",
  "fdjyk": "floating net profit and loss",
  "pcsl": "Closing Quantity",
  "cx": "revoke",
  "qrpc": "Confirm to close the position",
  "sx": "filter",
  "cz": "reset",
  "zdl": "knew",
  "kccg": "Successfully opened a position!",
  "xzfx": "choose direction",
  "lx": "type",
  "xgcc": "modify position",
  "szzyzs": "Set stop profit and stop loss",
  "szhb": "Crypto",
  "gjs": "Metal",
  "yy": "Crude",
  "jy": "Trade",
  "jmhb": "Crypto",
  "gdsj": "Pending order time",
  "gdsl": "Pending Order Quantity",
  "fs": "time"
 }
}



// WEBPACK FOOTER //
// ./src/utils/lang/en.js